import React from "react";

import { Grid, IconButton } from "@mui/material";

import { colors } from "@zapalacorp/tokens";
import { useTranslation } from "react-i18next";

import { ChevronDown } from "../../../../../../../components/Generic/Icons/ChevronDown";
import { ChevronUp } from "../../../../../../../components/Generic/Icons/ChevronUp";
import {
  ItemJobCustomerPortal,
  RoomJobCustomerPortal,
} from "../../../../../../../models/customer.portal";
import { DESTINATION } from "../../../../../../../util/enums";
import { RoomInfoText, RoomItemsInfo, RoomRowContainer } from "./styles";

interface RoomRowProps {
  collapseds: string[];
  room?: RoomJobCustomerPortal;
  roomName?: string;
  toggleCollapse: (room?: string) => void;
}

export const RoomRow = ({ collapseds, toggleCollapse, room, roomName }: RoomRowProps) => {
  const { t: translate } = useTranslation();

  const sumItensAndMaterials = (): number => {
    let itemsSum = 0;
    let materialSum = 0;

    if (room && room?.itemsJob) {
      itemsSum = room.itemsJob
        ?.filter(
          (item) => item?.destination?.name?.toLowerCase() !== DESTINATION.NOT_GOING?.toLowerCase()
        )
        ?.reduce((total: number, item: ItemJobCustomerPortal) => total + Number(item?.quantity), 0);
    }

    if (room && room?.materials) {
      room?.materials?.forEach((material) => {
        if (
          material?.serviceBooking?.isItem &&
          material?.destination?.name?.toLowerCase() !== DESTINATION.NOT_GOING?.toLowerCase()
        ) {
          materialSum += material.quantity;
        }
      });
    }

    return Number(itemsSum) + Number(materialSum);
  };

  const totalItems = sumItensAndMaterials();

  const renderArrowByCollapsed = (room?: string) => {
    const collapsed = collapseds.find((item) => item === room);

    if (collapsed) {
      return <ChevronUp width={20} height={20} color={colors.gray600} />;
    }

    return <ChevronDown width={20} height={20} color={colors.gray600} />;
  };

  return (
    <RoomRowContainer container direction="row" alignItems="center" justifyContent="space-between">
      <RoomInfoText>{roomName}</RoomInfoText>

      <Grid container item xs={6} alignItems="center" justifyContent="flex-end">
        <RoomItemsInfo>
          <li>
            <RoomInfoText>
              {totalItems}{" "}
              {totalItems > 0 ? translate("items").toLowerCase() : translate("item").toLowerCase()}
            </RoomInfoText>
          </li>
        </RoomItemsInfo>
        <IconButton onClick={() => toggleCollapse(roomName)}>
          {renderArrowByCollapsed(roomName)}
        </IconButton>
      </Grid>
    </RoomRowContainer>
  );
};
